import { render, staticRenderFns } from "./Regainsub.vue?vue&type=template&id=3e495031&scoped=true&"
import script from "./Regainsub.vue?vue&type=script&lang=js&"
export * from "./Regainsub.vue?vue&type=script&lang=js&"
import style0 from "./Regainsub.vue?vue&type=style&index=0&id=3e495031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e495031",
  null
  
)

export default component.exports